import { FavoriteSyncList } from '@/routes/_app/-dashboard/-components/favorite-sync-list.tsx'
import { FinishedWorksAmountCard } from '@/routes/_app/-dashboard/-components/finished-works-amount-card.tsx'
import { ReadWorksAmountCard } from '@/routes/_app/-dashboard/-components/read-works-amount.card.tsx'
import { TotalWorksCard } from '@/routes/_app/-dashboard/-components/total-works-card.tsx'
import { UnreadWorksAmountCard } from '@/routes/_app/-dashboard/-components/unread-works-amount-card.tsx'
import { WorksInfoChart } from '@/routes/_app/-dashboard/-components/works-info-chart.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/')({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: 'Dashboard | Okami',
      },
    ],
  }),
})

function RouteComponent() {
  return (
    <main className="flex flex-col gap-4">
      <h1 className="text-3xl font-bold tracking-tighter">Dashboard</h1>

      <section className="grid gap-4 md:grid-cols-4">
        <TotalWorksCard />
        <UnreadWorksAmountCard />
        <ReadWorksAmountCard />
        <FinishedWorksAmountCard />
      </section>

      <section className="grid gap-2 md:grid-cols-2">
        <WorksInfoChart />
        <FavoriteSyncList />
      </section>
    </main>
  )
}
